import React from 'react';
import styled from 'styled-components';

import PDFViewer from 'components/PDFViewer';

import CrossIcon from '../../../../components/Images/CrossDark';
import { Popup } from '../../../../components/Popup';
import { Box } from '../../../../designSystem';

const StyledHeading = styled.h1`
  font-size: 16px;
  font-weight: bold;
  line-height: 1.33;
  color: var(--Text500);
  margin: 8px 0;
`;

const StyledContainer = styled.div`
  height: 80%;
`;

const DataModal = ({ onClose, heading, url }) => {
  return (
    <Popup show close={onClose} className="fullview-modal">
      <Box variant="flex">
        <Box width={['100%']}>
          <StyledHeading className="text-align-center">{heading}</StyledHeading>
        </Box>
        <Box>
          <CrossIcon onClick={onClose} />
        </Box>
      </Box>
      <StyledContainer className="full-width">
        <PDFViewer pdfFile={url} />
      </StyledContainer>
    </Popup>
  );
};

export default DataModal;
